import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import MyNominationCard from "../../hyvid-awards/components/MyNominationCard";
import { Pagination } from "antd";
import { getPendingAwardList } from "../../../../../redux/employeeaward/employeeAwardState";

const ApprovalList = ({
}) => {
  const dispatch = useDispatch();
  const recordList = useSelector((state) => state.employeeAward.pendingAwardList?.items);
  const pagination = useSelector((state) => state.employeeAward.pendingAwardList?.pagination);
  const filters = useSelector((state) => state.employeeAward.pendingAwardList?.filters);

  const doSearch = (filters) => dispatch(getPendingAwardList(filters));

  useEffect(() => {
    dispatch(getPendingAwardList({ paginate: pagination?.per_page || 10 }));
  }, [dispatch, pagination?.per_page]);

  return (
    <HeaderComponent
      title="For Your Review"
      titleClass="text-[16px] font-medium"
      description="Client-submitted nominations waiting for your approval"
      descriptionClass="text-sm muted-text"
      cardBorder="border"
    >
      <div className="max-h-[600px] overflow-y-auto pr-2">
        <MyNominationCard 
          recordList={recordList} 
        />

        {pagination?.total > pagination?.per_page && (
          <div className="flex justify-end py-4">
            <Pagination
              current={pagination?.current_page}
              pageSize={pagination?.per_page}
              total={pagination?.total}
              showSizeChanger={false}
              onChange={(page) =>
                doSearch({
                  ...filters,
                  page,
                  paginate: pagination?.per_page,
                })
              }
            />
          </div>
        )}
      </div>
    </HeaderComponent>
  );
};

export default ApprovalList;